import axios from 'axios'
import { token } from '../core/auth'

const client = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'https://its.labparahita.com/api/',
  // baseURL: 'https://api.parahita.aksamedia.co.id/',
  auth: {
    username: 'pedece',
    password: '@@parahitax#'
  },
  withCredentials: process.env.VUE_APP_API_WITH_CREDENTIALS !== 'false'
})

/**
 * Kasih parameter token_api untuk semua
 * request axios jika posisi sedang login
 */
client.interceptors.request.use(config => {
  if (token && token.value) {
    if (config.method === 'get') {
      if (!config.params) {
        config.params = {}
      }

      config.params.token_api = token.value
    } else {
      if (!config.data) {
        config.data = {}
      }

      config.data.token_api = token.value
    }
  }

  // console.log(config)

  return config
})

export default client
